import type { IOrgProjectLocationRepository, OrgSubscribeInput } from '../repositories/IOrgProjectLocationRepository.js';
import type { OrgLocationEntity } from '../entities/OrgLocationEntity.js';

interface Deps { orgProjectLocationRepository: IOrgProjectLocationRepository; }

export function createSubscribeOrgLocationUseCase({ orgProjectLocationRepository }: Deps) {
  return async function subscribeOrgLocation(input: OrgSubscribeInput): Promise<OrgLocationEntity> {
    return orgProjectLocationRepository.subscribeOrg(input);
  };
}
